import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className=" text-white py-8 px-4 mt-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* ロゴ＆会社情報 */}
        <div>
          <h2 className="text-xl font-bold mb-2">CAMARAGO</h2>
          <p className="text-sm hidden">〒123-4567 東京都新宿区架空町1-2-3</p>
          <p className="text-sm mt-1 hidden">TEL: 03-1234-5678</p>
        </div>

        {/* サイトマップ */}
        <div>
          <h3 className="font-semibold mb-2">メニュー</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/" className="hover:underline">
                トップ
              </Link>
            </li>
            <li>
              <Link to="/wizard" className="hover:underline">
                診断スタート
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">
                お問い合わせ
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:underline">
                当社について
              </Link>
            </li>
          </ul>
        </div>

        {/* コピーライト */}
        <div className="flex items-end md:items-start justify-start md:justify-end">
          <p className="text-xs">&copy; 2025 CAMARAGO. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
